import React, { useRef } from "react";
import PropTypes from "prop-types";
import { TimePicker } from "@progress/kendo-react-dateinputs";
import "./TimePicker.scss";

/**
 * Time picker
 * @module
 * @param {string} name - Name
 * @param {func} onChange - Function invoked on value change
 * @param {Date | string} [value] - Current value
 * @param {bool} [required] - Is input required?
 * @param {bool} [disabled] - Is input readonly?
 * @param {bool} [autofocus] - Should input be focused?
 * @param {string} [validationMessage] - Validation message if field is invalid
 * @param {object} [steps] - Time steps
 * @param {func} [onBlur] - Function invoked on input blur
 * @param {number} [tabIndex] - Timepicker tab index
 */
const TimePickerComponent = (props) => {
  const ref = useRef(null);

  const onBlur = (e) => {
    if (props.onBlur && e?.target?.id === props.name) {
      props.onBlur(props.name, props.value);
    }
  };

  return (
    <TimePicker
      id={props.name}
      className={`form-input timepicker ${props.disabled ? "disabled-field" : props.required ? "required-field" : "default-field"}`}
      format="HH:mm"
      steps={props.steps ? props.steps : { hour: 1, minute: 5 }}
      onChange={(e) => props.onChange(props.name, e.target.value)}
      value={props.value}
      disabled={props.disabled}
      required={props.required}
      validationMessage={props.validationMessage || "Povinné"}
      ref={ref}
      onBlur={onBlur}
      tabIndex={props.tabIndex}
    />
  );
};

TimePickerComponent.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]),
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  autofocus: PropTypes.bool,
  validationMessage: PropTypes.string,
  steps: PropTypes.object,
  onBlur: PropTypes.func,
  tabIndex: PropTypes.number,
};

export default TimePickerComponent;
